import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story01.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story01'
const figure = articleFigure(dir)

export const story01: Article = {
  id: 1,
  slug: 'tech-makes-ghana-rivers-brown',
  order: 1,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('gold'),
  author: 'Albert Oppong-Ansah',
  region: [
    {
      name: 'Wassa Akropong',
      country: 'Ghana',
      coordinates: [-2.0833, 5.7833],
      impact: 'environmental',
    },
  ],
  impactList: ['environmental', 'human'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      { type: 'prose', blocks: [...t.prose[1]] }, // Ghana’s lifeblood and global connection
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[2]] },
      { type: 'prose', blocks: [...t.prose[3]] }, // The numbers behind the Gold
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[4]] },
      { type: 'prose', blocks: [...t.prose[5]] }, // The hidden cost of the global gold rush
      { type: 'prose', blocks: [...t.prose[6]] }, // A public health emergency in the making
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[7]] },
      { type: 'prose', blocks: [...t.prose[8]] }, // Government response
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[9]] },
      { type: 'prose', blocks: [...t.prose[10]] }, // Environmentalist doubts
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[11]] },
      { type: 'prose', blocks: [...t.prose[12]] }, // Who pays the real price?
      figure('05.jpg', t.captions[4]),
    ],
  },
}
